import React from "react";
import { useCurrentFrame, useVideoConfig } from "remotion";

export const GraphicNewsBackground: React.FC = () => {
  const frame = useCurrentFrame();
  const { height } = useVideoConfig();

  // Floating design confetti triangles (yellow and black)
  const TRIANGLES = [
    { x: 80, y: 120, size: 24, color: "#FFE600", rotate: 15 },
    { x: 920, y: 160, size: 22, color: "#000000", rotate: -45 },
    { x: 900, y: 550, size: 26, color: "#FFE600", rotate: 60 },
    { x: 100, y: 1350, size: 20, color: "#FFE600", rotate: 35 },
  ];

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "#F4F4F6",
        backgroundImage: "radial-gradient(rgba(0,0,0,0.06) 12%, transparent 12%)",
        backgroundSize: "20px 20px",
        overflow: "hidden",
        zIndex: 1,
      }}
    >
      {/* ── Graphic Red Backdrop Circle ── */}
      <div
        style={{
          position: "absolute",
          top: "38%",
          left: "50%",
          width: "720px",
          height: "720px",
          borderRadius: "50%",
          background: "radial-gradient(circle, #E11D48 0%, #BE123C 100%)",
          transform: `translate(-50%, -50%) scale(${1 + Math.sin(frame * 0.02) * 0.04})`,
          opacity: 0.16,
          pointerEvents: "none",
        }}
      />

      {/* ── Graphic Diagonal Stripe Pattern ── */}
      <div
        style={{
          position: "absolute",
          top: "30%",
          left: "22%",
          width: "550px",
          height: "320px",
          backgroundImage: "repeating-linear-gradient(45deg, rgba(0,0,0,0.04), rgba(0,0,0,0.04) 12px, transparent 12px, transparent 24px)",
          transform: `rotate(-12deg) scale(${1 + Math.cos(frame * 0.015) * 0.03})`,
          opacity: 0.8,
          pointerEvents: "none",
        }}
      />

      {/* ── Graphic Halftone Dotted Block ── */}
      <div
        style={{
          position: "absolute",
          top: "22%",
          right: "10%",
          width: "150px",
          height: "150px",
          backgroundImage: "radial-gradient(rgba(0,0,0,0.12) 20%, transparent 20%)",
          backgroundSize: "15px 15px",
          opacity: 0.8,
          pointerEvents: "none",
        }}
      />

      {/* ── Floating Confetti Triangles ── */}
      {TRIANGLES.map((tri, i) => {
        const driftY = Math.sin(frame * 0.03 + i) * 12;
        const driftX = Math.cos(frame * 0.02 + i) * 8;

        return (
          <svg
            key={i}
            width={tri.size}
            height={tri.size}
            viewBox="0 0 24 24"
            fill={tri.color}
            style={{
              position: "absolute",
              left: tri.x + driftX,
              top: tri.y + driftY,
              transform: `rotate(${tri.rotate + frame * 0.4}deg)`,
              opacity: 0.85,
              pointerEvents: "none",
            }}
          >
            <polygon points="12,2 22,22 2,22" />
          </svg>
        );
      })}

      {/* ── Footer Decoration Elements (slanted text, stars from reference) ── */}
      <div
        style={{
          position: "absolute",
          bottom: "100px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pointerEvents: "none",
          zIndex: 2,
        }}
      >
        {/* "FOLLOW US" label (slanted, right-aligned) */}
        <div
          style={{
            alignSelf: "flex-end",
            marginRight: "90px",
            marginBottom: "-10px",
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: "26px",
            fontWeight: 900,
            color: "#111625",
            transform: "rotate(-6deg)",
            opacity: 0.85,
          }}
        >
          FOLLOW US
        </div>

        {/* Decorative Stars and Octagons in bottom-right */}
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#000000"
          strokeWidth="2.5"
          style={{
            position: "absolute",
            right: "60px",
            bottom: "-60px",
            transform: `rotate(${frame * 0.5}deg)`,
            opacity: 0.8,
          }}
        >
          {/* 4-point star */}
          <path d="M12,2 L15,9 L22,12 L15,15 L12,22 L9,15 L2,12 L9,9 Z" fill="#000000" />
        </svg>

        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#000000"
          strokeWidth="2"
          style={{
            position: "absolute",
            right: "100px",
            bottom: "-30px",
            transform: `rotate(${-frame * 0.3}deg)`,
            opacity: 0.6,
          }}
        >
          {/* Outline star */}
          <path d="M12,2 L15,9 L22,12 L15,15 L12,22 L9,15 L2,12 L9,9 Z" />
        </svg>
      </div>

      {/* Subtle border outline */}
      <div
        style={{
          position: "absolute",
          top: "20px",
          bottom: "20px",
          left: "20px",
          right: "20px",
          border: "4px solid rgba(0,0,0,0.03)",
          pointerEvents: "none",
          zIndex: 3,
        }}
      />
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
